import Error from "../../Layouts/Error"
import InnerHeader from "../../Layouts/InnerHeader"
import Loading from "../../Layouts/Loading"
import { fa_number } from "../../utils/Persian"
import { ProductCategoryRequest, useCreateProdCategoryMutation, useDeleteProdCategoryMutation , useGetProductCatsQuery, useLazyGetProductCategoryQuery, useUpdateProdCategoryMutation } from "../../Redux/Apis/productApi"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"

export default function ProductCategory() {
    const [deletePost] = useDeleteProdCategoryMutation()
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetProductCatsQuery({})

    const [create,{isLoading : isCreateCatLoading}] = useCreateProdCategoryMutation()
    const [update,{isLoading : isUpdateCatLoading}] = useUpdateProdCategoryMutation()

    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const {
        data: categories,
        isLoading: isCatLoading,
    } = useGetProductCatsQuery({})
    
    const [formState, setFormState] = useState<ProductCategoryRequest>({
        name: "",
        order: NaN,
        parent_id: NaN
    })

    const [ loadCategory , {data: category, isSuccess: isCatSuccess}] = useLazyGetProductCategoryQuery()
    useEffect(() => {
        if(isCatSuccess && category) setFormState(category)
    },[isCatSuccess,category])

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const handleNumChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: +value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            if(isUpdate) {
                await update(formState).unwrap();
                toast.success('دسته بندی با موفقیت ویرایش گردید');
            }
            else {
                await create(formState).unwrap();
                toast.success('دسته بندی با موفقیت ایجاد شد');
            }

            setFormState({name:"",order:NaN})
            setErrorMsg(false) 
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess) {
        return(
            <div className="container-lg">
                <InnerHeader name="دسته بندی محصولات"/>
                {errorMsg && <div className="alert alert-danger" role="alert">
                    {errorMsg}
                </div>}
                <div className="row">
                    <form id="CatForm" onSubmit={onSubmit} className="row row-cols-lg-auto g-3 align-items-center border-top border-bottom p-0 m-0 pb-3 px-3 mb-4">
                        <div className="col-12">
                        <i className="zmdi zmdi-plus-circle text-secondary"></i>
                        </div>
                        <div className="col-12">
                            <label className="visually-hidden" htmlFor="caregory-name">نام دسته</label>
                            <input type="text" className="form-control" value={formState.name} onChange={handleChange} name="name" id="caregory-name" placeholder="نام دسته"/>
                        </div>

                        <div className="col-12">
                            <label className="visually-hidden" htmlFor="category-order">ترتیب اولویت</label>
                            <input type="number" min={1} lang="en" className="form-control" value={!Number.isNaN(formState.order) ? formState.order : ""} onChange={handleNumChange} name="order" id="category-order" placeholder="اولویت دسته" style={{direction:"rtl"}}/>
                        </div>

                        <div className="col-12">
                            <label className="visually-hidden" htmlFor="category_parent">زیر مجموعه</label>
                            <select name='parent_id' onChange={(e) => setFormState((prev) => ({ ...prev, 'parent_id': +e.target.value }))} value={formState.parent_id ? formState.parent_id : ""} className="form-select" id="category_parent">
                                <option>انتخاب دسته والد</option>
                                {
                                    isCatLoading ? 
                                        <option>در حال لود دسته ها...</option>
                                    : 
                                        categories && Object.values(categories).map((value:any,index:number) => 
                                            <option value={value.id} key={index}>{value.name}</option> )
                                }
                            </select>
                        </div>

                        {/* <div className="col-12">
                            <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="inlineFormCheck"/>
                            <label className="form-check-label" htmlFor="inlineFormCheck">
                                VIP
                            </label>
                            </div>
                        </div> */}

                        <div className="col-12">
                            <button type="submit" disabled={isCreateCatLoading || isUpdateCatLoading} className="btn btn-success">ایجاد دسته جدید</button>
                        </div>
                    </form>
                    {data && data.length > 0 ? <table className="table">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">نام</th>
                            <th scope="col">اولویت</th>
                            <th scope="col">دسته والد</th>
                            <th scope="col">اقدامات</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.map((value:any,index:number) => 
                            <tr key={index}>
                                <th scope="row">{fa_number(index + 1)}</th>
                                <td>{value.name}</td>
                                <td>{value.order ? fa_number(value.order) : "-"}</td>
                                <td>{value.parent_id ? value?.ProductCategory?.name : "-"}</td>
                                <td >
                                    <div className="d-grid gap-2 d-md-block justify-content-md-end">
                                        <button onClick={() => window.confirm('آیا از حذف این دسته اطمینان دارید؟') && deletePost(value.id)} className="btn btn-outline-danger me-md-2">حذف</button>
                                        <a href="#CatForm" type="button" onClick={() => {loadCategory(value.id); setIsUpdate(true)}} className="btn btn-primary">ویرایش</a>
                                    </div>
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table> 
                    :
                    <div className="alert d-flex align-items-center" role="alert">
                        <i className="zmdi zmdi-info"></i>
                        <div className="ms-2">
                        دسته ایی یافت نشد.
                        </div>
                    </div>
                    }
                </div>
            </div>
        )
    }

    else return <></>
}